import { Forward, Mail, MessageSquare, Reply, ReplyAll } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ComposeMode } from '../types';
import { ChannelPill, ComposerHeader } from '~/components/message-composer';

type ModeSelectorProps = {
  mode: ComposeMode;
  onClose?: () => void;
};

/** What the composer was opened as. It is stated, not chosen: whoever opened it
 *  already answered that, and offering the choice again asks it twice. */
export function ModeSelector({ mode, onClose }: ModeSelectorProps) {
  const { t } = useTranslation('mailbox');

  if (mode !== 'new') {
    const { icon: Icon, label } = {
      forward: { icon: Forward, label: t('Forward') },
      reply: { icon: Reply, label: t('Reply') },
      'reply-all': { icon: ReplyAll, label: t('Reply all') },
    }[mode];

    return (
      <ComposerHeader onClose={onClose}>
        <span className="flex items-center gap-2 px-3 text-sm font-medium text-foreground">
          <Icon className="size-4" strokeWidth={2.5} />
          {label}
        </span>
      </ComposerHeader>
    );
  }

  return (
    <ComposerHeader onClose={onClose}>
      <ChannelPill active icon={Mail} label={t('Email')} className="h-10" />
      <ChannelPill
        disabled
        icon={MessageSquare}
        label={t('SMS')}
        className="h-10"
      />
    </ComposerHeader>
  );
}
